import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { getDayOrdinal } from '@bridebook/toolbox/src/datepicker/get-day-ordinal';
import { IArticle } from '@bridebook/toolbox/src/schemas/article/types';
import { Box } from '@bridebook/ui';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { getI18n } from '@bridebook/web/lib/i18n/getI18n';
import { format } from '@bridebook/web/lib/i18n/utils/get-date-fns-format';
import { UrlHelper } from '@bridebook/web/lib/url-helper';
import { IMAGES_BASE_URL } from '@bridebook/toolbox/src/buildImageUrl';
import componentStyles from './author-profile.style';

interface IProps {
  article: IArticle | null;
  withSubtitle?: boolean;
}

const AuthorProfile = ({ withSubtitle, article }: IProps) => {
  const market = useMarket();
  const router = useRouter();
  const { t } = useTranslation('articles');
  const i18n = getI18n();
  const redirectToAuthorPage = () => {
    if (article?.post_author) {
      router.push(
        `/${market.prefix}${UrlHelper.author.nameSurname(`${article.post_author.first_name}-${article.post_author.last_name}`.toLowerCase())}`,
      );
    }
  };

  if (!article) {
    return null;
  }
  const dateForFormat = new Date(
    article?.post_modified.slice(0, article?.post_modified.length - 9),
  );
  const formatedDate = format(dateForFormat, `${getDayOrdinal(i18n.language)} MMM yyyy`);

  const styles = componentStyles();
  const description = article?.post_author.description;
  const authorAboutMe = description?.[market.language] || description?.en;
  return (
    <Box style={styles.wrapper}>
      <img
        src={
          article?.post_author?.profile_image?.full
            ? article?.post_author?.profile_image?.full
            : `${IMAGES_BASE_URL}/assets/article/default-author.jpg`
        }
        style={article?.post_author?.profile_image ? styles.image : styles.noImage}
      />
      {article?.post_author && (
        <Box style={styles.authorWrapper} onClick={redirectToAuthorPage}>
          <a
            href={`/${market.prefix}${UrlHelper.author.nameSurname(`${article.post_author.first_name}-${article.post_author.last_name}`.toLowerCase())}`}>
            <Box style={styles.authorName}>{article?.post_author.display_name}</Box>
          </a>
          {withSubtitle && authorAboutMe && <Box style={styles.authorAboutMe}>{authorAboutMe}</Box>}
          <Box style={styles.whenUpdated}>{t('last.updated', { formatedDate })}</Box>
        </Box>
      )}
    </Box>
  );
};

export default AuthorProfile;
